@if (icon()) {
  <svg class="icon" aria-hidden="true">
    <use [attr.xlink:href]="iconPath()" />
  </svg>
}
